import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = not auth, obj = auth
  const [loading, setLoading] = useState(true);
  const [authModal, setAuthModal] = useState(null); // null | { mode: 'login'|'signup', onSuccess, reason }

  useEffect(() => {
    const token = localStorage.getItem("th_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => {
        localStorage.removeItem("th_token");
        setUser(false);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("th_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    localStorage.setItem("th_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("th_token");
    setUser(false);
  };

  const openAuth = (opts = {}) => setAuthModal({ mode: "login", ...opts });
  const closeAuth = () => setAuthModal(null);

  return (
    <AuthContext.Provider
      value={{ user, loading, login, register, logout, authModal, setAuthModal, openAuth, closeAuth }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
